import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import ar from "./locales/ar.json";
import en from "./locales/en.json";

const bundles = { ar, en };
const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("lang") || "ar");

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    localStorage.setItem("lang", lang);
  }, [lang]);

  const setLang = useCallback((l) => setLangState(l === "en" ? "en" : "ar"), []);

  const t = useCallback((key, vars) => {
    const lookup = (bundle) =>
      key.split(".").reduce((o, k) => (o && o[k] !== undefined ? o[k] : undefined), bundle);
    let val = lookup(bundles[lang]);
    if (val === undefined) val = lookup(bundles.ar);
    if (val === undefined) return key;
    if (vars && typeof val === "string") {
      Object.entries(vars).forEach(([k, v]) => {
        val = val.replaceAll(`{${k}}`, String(v));
      });
    }
    return val;
  }, [lang]);

  const isRTL = lang === "ar";

  const pick = useCallback((obj, base) => {
    if (!obj) return "";
    return obj[`${base}_${lang}`] || obj[`${base}_ar`] || obj[`${base}_en`] || "";
  }, [lang]);

  return (
    <LangContext.Provider value={{ lang, setLang, t, isRTL, dir: isRTL ? "rtl" : "ltr", pick }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
